module.exports = __webpack_public_path__ + "img/skinAndCo1.b91b2630.jpg";